<div class="jku-page">

  <!-- ── Top black bar ─────────────────────────────────────────── -->
  <div class="jku-topbar">
    <div class="jku-topbar__inner">
      <div class="jku-topbar__user">
        @if (jkuUser.isAuthenticated()) {
        <mat-icon class="jku-topbar__user-icon">person</mat-icon>
        <span>{{ jkuUser.email() }}</span>
        @if (jkuUser.isJkuSso()) {
        <span class="jku-topbar__usertype" [attr.data-type]="jkuUser.userTypeCategory()">
          @if (jkuUser.userTypeCategory() === 'unknown') {
          {{ jkuUser.userType() }}
          } @else {
          {{ jkuUser.userTypeLabelKey() | translate }}
          }
        </span>
        }
        } @else {
        <button type="button" class="jku-topbar__login" (click)="jkuUser.loginWithJku()">
          <mat-icon class="jku-topbar__user-icon">login</mat-icon>
          <span>{{ 'JKU.TOPBAR.LOGIN' | translate }}</span>
        </button>
        }
      </div>
      <nav class="jku-topbar__links">
        <button type="button" class="jku-topbar__lang" [class.jku-topbar__lang--active]="lang.current() === 'de'"
          (click)="switchLanguage('de')">DE</button>
        <button type="button" class="jku-topbar__lang" [class.jku-topbar__lang--active]="lang.current() === 'en'"
          (click)="switchLanguage('en')">EN</button>
      </nav>
    </div>
  </div>

  <!-- ── Main white header ─────────────────────────────────────── -->
  <header class="jku-header">
    <div class="jku-header__inner">
      <a class="jku-header__logo" href="https://www.jku.at/campus/der-jku-campus/parken/" target="_blank"
        rel="noopener noreferrer">
        <img class="jku-header__logo-img" src="assets/jku/jku-60-jahre-logo.svg"
          alt="Johannes Kepler Universität Linz — 60 Jahre" />
      </a>
      <!-- The JJames mark alone, at the same size as the JKU logo — no caption. -->
      <div class="jku-header__partner">
        <img class="jku-header__partner-img" src="assets/logo-jjames.webp" alt="JJames Smartparking" />
      </div>
    </div>
    <div class="jku-header__rainbow">
      <img class="jku-header__rainbow-img" src="assets/jku/jku-rainbow-banner.png" alt="JKU Rainbow Accent" />
    </div>
  </header>

  <!-- ── Content container ─────────────────────────────────────── -->
  <!-- No "back to JJAMES" arrow: the sidebar below now reaches every screen, and sending a
       JKU user into the JJames-branded shell is the brand switch this layout exists to avoid. -->
  <main class="jku-content">
    <div class="jku-content__box">
      <aside class="jku-content__sidebar">
        <nav>
          @for (item of sidebarItems(); track item.labelKey) {
          @if (!item.enabled) {
          <span class="jku-content__sidebar-link jku-content__sidebar-link--disabled"
            [attr.title]="'JKU.SIDEBAR.PHASE2' | translate">{{ item.labelKey | translate }}</span>
          } @else if (item.route) {
          <a class="jku-content__sidebar-link" [routerLink]="item.route" routerLinkActive="jku-content__sidebar-link--active"
            [routerLinkActiveOptions]="{ exact: true }">{{ item.labelKey | translate }}</a>
          } @else {
          <button type="button" class="jku-content__sidebar-link jku-content__sidebar-link--action"
            (click)="item.action!()">{{ item.labelKey | translate }}</button>
          }
          }
        </nav>
      </aside>
      <section class="jku-content__main">
        <router-outlet></router-outlet>
      </section>
    </div>
  </main>

</div>